import { createQueryKeys } from "@lukemorales/query-key-factory";
import { queryOptions, useQuery, useQueryClient } from "@tanstack/react-query";

import { type Container } from "@/builder/types";
import { useMutationWithError } from "@/hooks";
import { adminApi } from "@/lib/api";

import { type AdminProfileBuilder } from "../types";

export const profileBuilder = createQueryKeys("admin-profile-builder", {
  builder: null,
});

export const fetchProfileBuilderQueryOptions = () =>
  queryOptions({
    ...profileBuilder.builder,
    queryFn: () =>
      adminApi
        .get<AdminProfileBuilder>(`profile/builder`)
        .then((response) => response.data),
  });

export const useFetchProfileBuilder = () =>
  useQuery(fetchProfileBuilderQueryOptions());

export interface ProfileBuilderRequest {
  containers: Container[];
}

export const useUpdateProfileBuilder = () => {
  const queryClient = useQueryClient();
  return useMutationWithError({
    mutationFn: (data: ProfileBuilderRequest) =>
      adminApi.put(`profile/builder`, data).then((response) => response.data),
    onSuccess: () => {
      queryClient.invalidateQueries(profileBuilder.builder);
    },
  });
};
